import classNames from 'classnames';
import './LabelSwitch.scss';

interface Props<T> {
  onClick: (v: T) => () => void;
  activeItem: T;
  items: { value: T; label: string }[];
  className?: string;
}

export default function LabelSwitch<T>({
  onClick,
  activeItem,
  items,
  className = '',
}: Props<T>) {
  return (
    <div className={`LabelSwitch ${className}`}>
      <div className='row LabelSwitch__row position-relative gx-0'>
        <div
          className={classNames(
            'w-50 position-absolute LabelSwitch__indicator h-100',
            {
              'LabelSwitch__indicator--left': activeItem === items[0].value,
              'LabelSwitch__indicator--right': activeItem === items[1].value,
            }
          )}
        />
        {items.map((item) => (
          <div className='col' key={item.label}>
            <button
              className='position-relative d-block LabelSwitch__btn py-1 w-100'
              onClick={onClick(item.value)}
              disabled={activeItem === item.value}
              type='button'
            >
              {item.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
